import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { withTheme } from 'common/styling/theme';

import { connect } from 'react-redux';
import ChangeEmailForm from '../ChangeEmailForm';
import ChangePasswordForm from '../ChangePasswordForm';
import { staticStyles, getDynamicStyles } from './style';
import ApiTokens from '../ApiTokens';

const SecurityPanelContent = ({ theme, profile }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="SecurityPanelContent_container">
      <div className="SecurityPanelContent">
        <ChangeEmailForm />
        <ChangePasswordForm />
      </div>
      {profile.isStaff && <ApiTokens />}
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

SecurityPanelContent.propTypes = {
  theme: PropTypes.object,
};

SecurityPanelContent.defaultProps = {
  theme: {},
};

export default compose(
  withTheme(),
  connect(state => ({
    profile: state.user.profile,
  }))
)(SecurityPanelContent);

export { SecurityPanelContent };
